<script setup lang="ts">
import type { VideoCardHomeFeedFooterProps } from './types';

defineProps<VideoCardHomeFeedFooterProps>();
</script>

<template>
	<div
		class="absolute inset-x-0 bottom-0 z-10 flex flex-col px-3 pb-3 pt-0 font-sans text-white drop-shadow-sm lg:px-4 lg:pb-4"
	>
		<div class="flex flex-col">
			<h3
				v-if="formattedPrice"
				class="font-matter-sq text-sm font-normal leading-[150%] md:text-[18px]"
			>
				{{ formattedPrice }}
			</h3>
			<h2 v-if="region" class="truncate text-sm font-medium leading-5">
				{{ region }}
			</h2>
			<h4 v-if="cityState" class="truncate text-xs font-medium leading-[150%]">
				{{ cityState }}
			</h4>
		</div>
	</div>
</template>
